import { createRouter, createWebHistory } from "vue-router";
import LoginPage from "../views/MainHomePages/LoginPage.vue";

const routes = [
  {
    path: "/",
    name: "LoginPage",
    component: LoginPage,
  },
  {
    path: "/LandingPage",
    name: "LandingPage",
    component: () =>
      import(
        /* webpackChunkName: "LandingPage" */ "../views/MainHomePages/LandingPage.vue"
      ),
    children: [
      {
        path: "/PlateLookUp",
        name: "PlateLookUp",
        component: () =>
          import(
            /* webpackChunkName: "PlateLookUp" */ "../views/ChildHomePages/PlateLookUp.vue"
          ),
      },
      {
        path: "/MyProfile",
        name: "MyProfile",
        component: () =>
          import(
            /* webpackChunkName: "LandingPage" */ "../views/ChildHomePages/MyProfile.vue"
          ),
      },
      {
        path: "/MyActivitiesPage",
        name: "MyActivitiesPage",
        component: () =>
          import(
            /* webpackChunkName: "LandingPage" */ "../views/ChildHomePages/MyActivitiesPage.vue"
          ),
      },
      {
        path: "/Chat",
        name: "Chat",
        component: () =>
          import(
            /* webpackChunkName: "LandingPage" */ "../views/ChildHomePages/Chat.vue"
          ),
      },
      {
        path: "/VideoCall",
        name: "VideoCall",
        component: () =>
          import(
            /* webpackChunkName: "LandingPage" */ "../views/ChildHomePages/VideoCallPage.vue"
          ),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
